<div class="space-y-4">
  <div class="p-3 rounded-lg border border-gray-200 dark:border-gray-700 grid grid-cols-1 md:grid-cols-[auto_auto_auto_auto_auto] gap-2 items-end">
    <div>
      <label class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1">Minutos antes</label>
      <input type="number" min="1" [(ngModel)]="newMinutes" placeholder="60"
        class="w-24 px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white">
    </div>
    <div>
      <label class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1">Método</label>
      <select [(ngModel)]="newMethod"
        class="px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white">
        @for (m of methods; track m) { <option [ngValue]="m">{{ methodLabels[m] }}</option> }
      </select>
    </div>
    <div>
      <label class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1">Destino</label>
      <select [(ngModel)]="newTarget"
        class="px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white">
        @for (t of targets; track t) { <option [ngValue]="t">{{ targetLabels[t] }}</option> }
      </select>
    </div>
    <div>
      <label class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1">Plantilla de correo</label>
      <select [(ngModel)]="newEmailTemplateId"
        class="w-48 px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white">
        <option [ngValue]="null">— Predeterminada —</option>
        @for (t of templates; track t.id) { <option [ngValue]="t.id">{{ t.name }}</option> }
      </select>
    </div>
    <button type="button" (click)="add()" [disabled]="saving || !newMinutes"
      class="px-3 py-1.5 text-sm rounded-lg font-medium bg-brand-500 text-white hover:bg-brand-600 disabled:opacity-50">
      + Agregar
    </button>
  </div>

  @if (loading) {
    <p class="text-sm text-gray-500 dark:text-gray-400">Cargando...</p>
  } @else if (items.length === 0) {
    <p class="text-sm text-gray-500 dark:text-gray-400">No hay recordatorios configurados.</p>
  } @else {
    <ul class="divide-y divide-gray-200 dark:divide-gray-700 border border-gray-200 dark:border-gray-700 rounded-lg">
      @for (item of items; track item.id) {
        <li class="py-2 px-3 flex items-center justify-between gap-3">
          <div class="flex items-center gap-3 flex-wrap">
            <span class="font-medium text-gray-900 dark:text-white text-sm">{{ item.minutesBefore }} min antes</span>
            <span class="text-xs px-2 py-0.5 rounded bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300">{{ methodLabels[item.method] || item.method }}</span>
            <span class="text-xs px-2 py-0.5 rounded bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300">{{ targetLabels[item.target] || item.target }}</span>
            @if (item.idEmailTemplate) { <span class="text-xs text-gray-500 dark:text-gray-400">{{ templateName(item.idEmailTemplate) }}</span> }
            @if (!item.isActive) { <span class="text-xs px-2 py-0.5 rounded bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300">inactivo</span> }
          </div>
          <div class="flex items-center gap-2">
            <button type="button" (click)="toggle(item)"
              class="text-xs px-2 py-1 rounded border border-gray-300 dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-700 dark:text-gray-300">
              {{ item.isActive ? 'Desactivar' : 'Activar' }}
            </button>
            <button type="button" (click)="remove(item)"
              class="text-xs px-2 py-1 rounded border border-error-300 text-error-600 hover:bg-error-50">
              Eliminar
            </button>
          </div>
        </li>
      }
    </ul>
  }
</div>
